import React, { useState } from "react";
import { Button, Input, Alert, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { disable2FA, setup2FA, verifySetup2FA } from "../../redux/Actions";
import { getAuthReducer } from "../../redux/Reducer/authReducer";

const { Text } = Typography;

const TwoFactorSetup = () => {
  const dispatch = useDispatch();

  // 👉 FIX: Destructure the new 'is2FAActive' state from the reducer
  const {
    setup2FAData,
    isSettingUp2FA,
    isVerifyingSetup2FA,
    isDisabling2FA,
    is2FAActive, // Grabbing our reliable flag
  } = useSelector(getAuthReducer);

  const [otpCode, setOtpCode] = useState("");

  const handleEnableClick = () => dispatch(setup2FA());

  const handleDisableClick = () => {
    dispatch(disable2FA());
  };

  const handleVerifySetup = () => {
    if (otpCode.length >= 6) {
      dispatch(verifySetup2FA({ otp: otpCode }));
      setOtpCode(""); // clear input on submit
    }
  };

  const renderQRCode = (qrCodeData) => {
    if (!qrCodeData) return null;

    let imageSource = qrCodeData;

    if (typeof qrCodeData === "string" && qrCodeData.trim().startsWith("<")) {
      imageSource = `data:image/svg+xml;utf8,${encodeURIComponent(qrCodeData)}`;
    }

    return (
      <img
        src={imageSource}
        alt="2FA QR Code"
        style={{
          width: "200px",
          height: "200px",
          border: "1px solid #ddd",
          padding: "10px",
          borderRadius: "8px",
          backgroundColor: "#fff",
          objectFit: "contain",
        }}
      />
    );
  };

  const isButtonDisabled = otpCode.length < 6;

  return (
    <div
      style={{
        padding: "24px",
        border: "1px solid #f0f0f0",
        borderRadius: "8px",
        background: "#fff",
        height: "100%",
      }}
    >
      <h4 style={{ marginBottom: "10px", color: "#252A4D" }}>
        Two-Factor Authentication (2FA)
      </h4>
      <p style={{ color: "#555", fontSize: "13px", marginBottom: "20px" }}>
        Add an extra layer of security to your account. Once enabled, you will
        be required to enter a 6-digit code from Google Authenticator every time
        you log in.
      </p>

      {setup2FAData?.qr_code ? (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Alert
            message="Scan this QR code with Google Authenticator"
            type="info"
            showIcon
            className="mb-3"
          />

          {renderQRCode(setup2FAData.qr_code)}

          <div style={{ marginTop: "15px" }}>
            <Text type="secondary">
              Or enter code manually: <br />
              <strong
                style={{
                  letterSpacing: "1px",
                  color: "#000",
                  fontSize: "16px",
                }}
              >
                {setup2FAData.secret}
              </strong>
            </Text>
          </div>

          <Input
            placeholder="Enter 6-digit OTP"
            maxLength={6}
            value={otpCode}
            onChange={(e) => setOtpCode(e.target.value)}
            style={{
              marginTop: "20px",
              textAlign: "center",
              letterSpacing: "2px",
              fontSize: "18px",
            }}
          />

          <Button
            type="primary"
            block
            className="mt-3"
            style={{
              backgroundColor: isButtonDisabled ? undefined : "#252A4D",
              borderColor: isButtonDisabled ? undefined : "#252A4D",
              height: "45px",
              fontWeight: "bold",
            }}
            onClick={handleVerifySetup}
            loading={isVerifyingSetup2FA}
            disabled={isButtonDisabled}
          >
            Verify & Enable 2FA
          </Button>
        </div>
      ) : // 👉 FIX: Use is2FAActive to control the view
      is2FAActive ? (
        <div style={{ marginTop: "20px" }}>
          <Alert
            message="Two-Factor Authentication is currently ENABLED."
            type="success"
            showIcon
            className="mb-4"
          />
          <Button
            danger
            type="primary"
            onClick={handleDisableClick}
            loading={isDisabling2FA}
            style={{ height: "40px" }}
          >
            Disable 2FA
          </Button>
        </div>
      ) : (
        <div style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            onClick={handleEnableClick}
            loading={isSettingUp2FA}
            style={{ backgroundColor: "#252A4D", height: "40px" }}
          >
            Setup 2FA Now
          </Button>
        </div>
      )}
    </div>
  );
};

export default TwoFactorSetup;
